<template>
  <div
    v-resize="handleResize"
    class="w-full gap-8 md:gap-16 flex flex-col overflow-y-auto"
  >
    <LandingHeader @scroll-to-section="scrollToSection" />

    <LandingWelcome
      class="max-w-3xl w-full mb-8"
      @scroll-to-section="scrollToSection"
    />

    <div id="demo" class="max-w-7xl w-full px-4 pb-8 md:pb-16 mx-auto">
      <LandingDemo />
    </div>

    <div id="how-it-works" class="max-w-7xl w-full px-4 py-8 md:py-16 mx-auto">
      <LandingHowItWorks />
    </div>

    <div id="pricing" class="max-w-7xl w-full px-4 py-8 md:py-16 mx-auto">
      <LandingPricing />
    </div>

    <div id="faq" class="max-w-7xl w-full px-4 py-8 md:py-16 mx-auto">
      <LandingFAQ />
    </div>

    <div class="max-w-7xl w-full px-4 py-8 md:py-16 mx-auto">
      <LandingLastBlock @scroll-to-section="scrollToSection" />
    </div>

    <LandingFooter @scroll-to-section="scrollToSection" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import LandingHeader from '@/components/Landing/LandingHeader.vue'
import LandingWelcome from '@/components/Landing/LandingWelcome.vue'
import LandingDemo from '@/components/Landing/LandingDemo.vue'
import LandingHowItWorks from '@/components/Landing/LandingHowItWorks.vue'
import LandingPricing from '@/components/Landing/LandingPricing.vue'
import LandingFAQ from '@/components/Landing/LandingFAQ.vue'
import LandingFooter from '@/components/Landing/LandingFooter.vue'
import LandingLastBlock from '@/components/Landing/LandingLastBlock.vue'

export default {
  name: 'TheLanding',

  components: {
    LandingHeader,
    LandingWelcome,
    LandingDemo,
    LandingHowItWorks,
    LandingPricing,
    LandingFAQ,
    LandingLastBlock,
    LandingFooter
  },

  data: () => ({
    windowWidth: 0
  }),

  computed: {
    ...mapState('user', ['user'])
  },
  methods: {
    handleResize({ x }) {
      this.windowWidth = x
    },

    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        // window.history.pushState(null, null, `#${sectionId}`)
      }
    }
  }
}
</script>
